export class CustomerContext {
  constructor(coordinates, postcode, city) {
    this.coordinates = coordinates;
    if (postcode) this.postcode = postcode;
    if (city) this.city = city;
  }
  getMainStoreId() {
    return this.mainStoreId;
  }
  getCoordinates() {
    return this.coordinates;
  }
  getPostcode() {
    return this.postcode;
  }
  getCity() {
    return this.city;
  }
  withMainStoreId(storeId) {
    this.mainStoreId = storeId;
    return this;
  }
}